var examStatuses = [
  { "name": "مدت زمان آزمون تمام شده است", value: 0, accessType: 0, nameEn: "timeout" },
  { "name": "رد شده", value: 1, accessType: 1, nameEn: "failed " },
  { "name": "قبول شده", value: 2, accessType: 2, nameEn: "pass" },
  { "name": "در حال برگزاری آزمون", value: 3, accessType: 3, nameEn: "idle" },
  { "name": "پرداخت نشده", value: 4, accessType: 4, nameEn: "waitForPayment " },
  { "name": "پرداخت شده", value: 5, accessType: 5, nameEn: "paid  " },
];

export default examStatuses;